module.exports = __webpack_public_path__ + "static/media/1700.2698fd63.jpg";